import {Document, Line, Page, Svg, Text, View} from "@react-pdf/renderer";
import {styles} from "./ModelAPdf";

export function ModelCPdf(props) {
    const {modelCTempObject} = props;

    return <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Model C Inschrijvingsformulier 'sector'</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Provincie: </Text>
                            <Text style={styles.fieldText}>{modelCTempObject.provincie}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Sector: </Text>
                            <Text style={styles.fieldText}>{modelCTempObject.sector}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Sectornr: </Text>
                            <Text style={styles.fieldText}>{modelCTempObject.sectornr}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>

                <Text style={styles.smallestTile}>Voorzitter</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postnrVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telgsmemailVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Secretaris</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postnrSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telgsmemailSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Penningsmeester</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamPenningsmeester}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrPenningsmeester}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postnrPenningsmeester}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telgsmemailPenningsmeester}</Text>
                    </View>
                </View>
            </View>


        </Page>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Raadsleden</Text>

                <Text style={styles.smallestTile}>Raadslid 1</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamRaadsLid1}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrRaadsLid1}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postNrGemeenteRaadsLid1}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telGsmEmailRaadsLid1}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 2</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamRaadsLid2}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrRaadsLid2}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postNrGemeenteRaadsLid2}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telGsmEmailRaadsLid2}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 3</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamRaadsLid3}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrRaadsLid3}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postNrGemeenteRaadsLid3}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telGsmEmailRaadsLid3}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 4</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamRaadsLid4}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrRaadsLid4}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postNrGemeenteRaadsLid4}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telGsmEmailRaadsLid4}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 5</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.naamVoornaamRaadsLid5}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.straatNrRaadsLid5}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.postNrGemeenteRaadsLid5}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelCTempObject.telGsmEmailRaadsLid5}</Text>
                    </View>
                </View>
            </View>
        </Page>
    </Document>
}